import {
  Attribute,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

import { environment } from '@environment';

@JsonApiModelConfig({
  baseUrl: `${environment.backendBaseUrl}/api/v1`,
  type: 'member_reports',
})
export class MemberReport extends JsonApiModel {
  // Deprecated JSONApiModel. Serialized keys might not be synced with BE.
  // We use this in reporting where we do direct sql queries
  @Attribute({ serializedName: 'member_id' })
  memberId!: string;

  @Attribute({ serializedName: 'full_name' })
  memberName!: string;

  @Attribute({ serializedName: 'email' })
  memberEmail!: string;

  @Attribute({ serializedName: 'username' })
  memberUsername!: string;

  @Attribute({ serializedName: 'last_activity' })
  lastActivity!: Date;

  @Attribute({ serializedName: 'groups_count' })
  groupsCount!: number;

  @Attribute({ serializedName: 'courses_count' })
  coursesCount!: number;

  @Attribute({ serializedName: 'courses_not_started' })
  coursesNotStarted!: number;

  @Attribute({ serializedName: 'courses_running' })
  coursesRunning!: number;

  @Attribute({ serializedName: 'courses_missed' })
  coursesMissed!: number;

  @Attribute({ serializedName: 'courses_completed' })
  coursesCompleted!: number;

  @Attribute({ serializedName: 'time_spent_in_seconds' })
  timeSpentInSeconds!: number;

  @Attribute({ serializedName: 'net_time_in_seconds' })
  netTimeInSeconds!: number;

  @Attribute({ serializedName: 'gamification_score' })
  gamificationScore!: number;

  @Attribute({ serializedName: 'course_progress_avg' })
  courseProgressAvg!: string;

  @Attribute({ serializedName: 'course_completion_avg' })
  courseCompletionAvg!: string;

  @Attribute({ serializedName: 'course_success_avg' })
  courseSuccessAvg!: string;

  @Attribute({ serializedName: 'course_score_avg' })
  courseScoreAvg!: string;

  @Attribute({ serializedName: 'fullpath' })
  orgaFullPath!: string;

  @Attribute({ serializedName: 'level_number' })
  orgaLevel!: string;

  @Attribute({ serializedName: 'orga_name' })
  orgaName!: string;

  @Attribute({ serializedName: 'credits' })
  credits!: number;

  @Attribute({ serializedName: 'updated_at' })
  updatedAt!: Date;

  @Attribute({ serializedName: 'trainings_with_deadlines' })
  trainingsWithDeadlines!: number;

  @Attribute({ serializedName: 'deadlines_expired' })
  deadlinesExpired!: number;

  @Attribute({ serializedName: 'deadlines_upcoming' })
  deadlinesUpcoming!: number;

  @Attribute({ serializedName: 'deadlines_on_track' })
  deadlinesOnTrack!: number;

  @Attribute({ serializedName: 'gradable_trainings_successful' })
  gradableTrainingsSuccessful!: number;

  @Attribute({ serializedName: 'gradable_trainings_failed' })
  gradableTrainingsFailed!: number;

  @Attribute({ serializedName: 'completed' })
  completed!: number;

  @Attribute({ serializedName: 'hire_date' })
  hireDate!: string | null;

  @Attribute({ serializedName: 'idd_relevant' })
  iddRelevant!: string;
}
